module.exports = __webpack_public_path__ + "static/img/rail-mount-bracket.5a1e371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/general-frames/rail-mount-bracket.jpg
// module id = 723
// module chunks = 0